<template>
    <div class="sui-image"
        :style="{
            backgroundColor
        }">
        <transition name="sui-animation--fade">
            <div class="sui--wrapper"
                v-show="loaded"
                :style="style"></div>
        </transition>
        <sui-icon
            name="loading"
            v-if="loading && !loaded"
            :fill="3"></sui-icon>
        <img
            :src="url"
            @load.once="loaded = true">
    </div>
</template>

<script>
import SuiIcon from '../icon/icon'

export default {
    name: 'sui-image',

    components: {
        SuiIcon
    },

    props: {

        // 图片路径
        src: {
            type: String,
            required: true
        },

        backgroundColor: {
            type: String,
            default: 'rgba(0, 0, 0, 0.06)'
        },

        backgroundSize: {
            type: String,
            default: 'cover'
        },

        // 是否展示加载动画
        loading: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            loaded: false, // 是否已加载完成
        }
    },

    computed: {

        // 图片协议转换为 https
        url() {
            return this.src ? this.src.replace(/^(https?:)?\/\//g, 'https://') : ''
        },

        style() {
            return {
                'background-image': `url(${ this.url })`,
                'background-size': this.backgroundSize,
            }
        },
    }
}
</script>

<style lang="postcss">
.sui-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .sui--wrapper {
        flex: none;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
    }
    > .sui-icon {
        flex: none;
        animation: 1500ms linear infinite rotate;
        @media (orientation: portrait) {
            width: 5.6vw;
            height: 5.6vw;
        }
        @media (orientation: landscape) {
            width: 3.148vw;
            height: 3.148vw;
        }
    }
    img {
        display: none;
    }
}
</style>
